import { Color, MeshPhysicalMaterial, NearestMipmapLinearFilter, Vector2 } from 'three';
import { onMounted } from 'vue';

import { KTXLoader } from '@resn/gozer-loading';

import { createPackSceneObjectMaterial } from '../../materials/PackSceneObjectMaterial';
import { useBaseObject } from './useBaseObject';

export const usePokeball = ({ object }) => {
    const ball = object.getObjectByName('pokeball-inner');
    const main = ball.children[0];
    const bolt = ball.children[1];

    const mainMaterial = createPackSceneObjectMaterial({
        roughness: 0.5,
        metalness: 0.1,
        color: new Color('#ffda3a'),
    });
    // const boltMaterial = createPackSceneObjectMaterial(
    //     {
    //         color: new Color('white'),
    //         roughness: 1,
    //         metalness: 0,
    //     },
    //     { uUseMatcap: { value: false } }
    // );

    const boltMaterial = new MeshPhysicalMaterial({
        color: new Color('white'),
        roughness: 1,
        metalness: 0,
    });

    main.material = mainMaterial;
    bolt.material = boltMaterial;
    bolt.ignoreUpdates = true;

    // const material = createPackSceneObjectMaterial(
    //     {
    //         roughness: 1,
    //         metalness: 0,
    //         // normalMap: ball.material.normalMap,
    //         color: new Color('#ffda3a'),
    //         // normalScale: new Vector2().setScalar(1),
    //     },
    //     {
    //         uMaskColor: { value: new Color('white') },
    //         uMaskRoughnessFactor: { value: 1 },
    //         uMaskMetalnessFactor: { value: 0 },
    //     }
    // );
    // material.defines.USE_MASK = '';

    useBaseObject({ object, name: 'Pokeball' });

    // const loader = new KTXLoader(
    //     '/textures/pack/3d/pokeball/pokeball-mask-inverse-1024-etc1s.ktx2'
    // );
    // loader.start().then((texture) => {
    //     texture.flipY = false;

    //     material.uMaskMap = texture;
    // });

    onMounted(() => {
        window.pokeball = ball;
        window.pokeballMaterial = ball.material;
    });

    return {
        ball,
        mainMaterial,
        boltMaterial,
    };
};
